module.exports = __webpack_public_path__ + "static/img/aquaman2_th.2840bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/aquaman2_th.png
// module id = Eg2z
// module chunks = 1